import request from '@/utils/request'
import { method } from '@/utils/constant'

const { POST, GET } = method

export default {
  // 下拉框信息 0 注册企业类型 1 所属协会 2 非施工企业类型 3 会员类型
  async getSelectData(param) {
    return request({
      method: GET,
      url: `/member/member/select/${param.type}`,
    })
  },

  // 省
  async getProvinceList() {
    return request({
      method: GET,
      url: '/member/member/api/region/province',
      noTimestamp: true,
    })
  },

  // 市
  async getCityList(param) {
    return request({
      method: GET,
      url: `/member/member/api/region/city/${param.id}`,
      noTimestamp: true,
    })
  },

  // 区
  async getAreaList(param) {
    return request({
      method: GET,
      url: `/member/member/api/region/area/${param.id}`,
      noTimestamp: true,
    })
  },

  // 查看资质等级 0 总承包资料类型 1 专业承包资质类型
  async getContractingType(param) {
    return request({
      method: GET,
      url: `/member/member/contracting/format/${param.type}`,
    })
  },

  // 获取公告信息 0 文件公告 1 会员服务信息
  async getNotice(params) {
    return request({
      method: POST,
      url: '/member/notice/list',
      params,
    })
  },

  // 获取公告详情
  async getNoticeDetail(param) {
    return request({
      method: GET,
      url: `/member/notice/detail/${param.id}`,
    })
  },

  // 团体会员列表
  async getGroupMemberList(params) {
    return request({
      method: POST,
      url: '/member/member/group/list',
      params: {
        ...params,
      },
    })
  },

  // 单位会员列表
  async getUnitMemberList(params) {
    return request({
      method: POST,
      url: '/member/member/one/list',
      params: {
        ...params,
      },
    })
  },

  // 3a
  async get3aMemberList(params) {
    return request({
      method: POST,
      url: '/member/member/3A/list',
      params: {
        ...params,
      },
    })
  },

  async getGroupName(name) {
    return request({
      method: POST,
      url: '/member/member/group/get/' + encodeURIComponent(name),
    })
  },

  async getUnitName(name) {
    return request({
      method: POST,
      url: '/member/member/one/get/' + encodeURIComponent(name),
    })
  },

  async get3aName(name) {
    return request({
      method: POST,
      url: '/member/member/3A/get/' + encodeURIComponent(name),
    })
  },
}
